import React from "react";

const translations = {
  en: {
    title: "Why should you choose Rejuvenation",
    paragraph:
      "The goal of our beauty device systems is to make innovation accessible and deliver it straight into your hands. Combining revolutionary scientific research and groundbreaking technology, they yield results that are visible, clinically-proven, and powerful. And being named the World’s #1 Brand for Beauty Device Systems from 4 consecutive years, from 2017 to 2020 is proof of that.",
  },
  ar: {
    title: "لماذا يجب عليك اختيار التجديد (Rejuvenation)",
    paragraph:
      "تهدف أنظمة أجهزة الجمال الخاصة بنا إلى جعل الابتكار في متناول يدك مباشرة. من خلال الجمع بين الأبحاث العلمية الثورية والتكنولوجيا المتقدمة، فإنها توفّر نتائج مرئية مثبتة سريريًا وفعّالة. وتم تصنيفها كأفضل علامة تجارية لأجهزة الجمال على مستوى العالم لمدة 4 سنوات متتالية من 2017 إلى 2020، مما يُثبت ذلك.",
  },
};

const WhyRejuvenation = ({ language = "en" }) => {
  const { title, paragraph } = translations[language];
  const dir = language === "ar" ? "rtl" : "ltr";

  return (
    <div className="why-rejuvenation-section" dir={dir}>
      <div className="why-left">
        <h3>{title}</h3>
      </div>
      <div className="why-right">
        <p>{paragraph}</p>
      </div>
    </div>
  );
};

export default WhyRejuvenation;
